import {charcoal} from '../../sass/v2/_exports.sass';

export const CheckmarkIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3334 20.7814L8.94271 16.3907L7.05737 18.276L13.3334 24.552L26.276 11.6094L24.3907 9.72403L13.3334 20.7814Z"
        fill={color}
      />
    </svg>
  );
};
